<template>
  <div>
    <template v-if="itemList.length > 0 || scrollFlag">
      <div class="list_box">
        <Item
          v-for="item in itemList"
          :key="item.articleId"
          :details="item"
        >
        </Item>
      </div>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
    </template>
    <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
  </div>
</template>

<script>
import Item from "@/components/pager/courseItme";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
import mixin from "@/mixins";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        articleType: 9,
        pageNo: 1,
        pageSize: 6,
      },
    };
  },
  created() {
    // 论文列表
    this.getItemList(this.params);
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.list_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &:after {
    content: "";
    width: 380px;
  }
}
</style>